<template>
	<v-dialog
			:value="isNewOrders"
			persistent
			width="740"
	>
		<div class="planerWorkOrderPopup">
			<div class="planerWorkOrderPopup_title">
				<span>NEW WORK ORDERS</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<new-orders-table
					v-if="newWorkOrderFilter"
					:filter="newWorkOrderFilter"
					:list-items="newWorkOrderList"
					:permissions="permissions"
					:workOrderId="workOrderId"
					@updateNewOrder="onNewOrder"
					@updateCommentsPopup="onCommentsPopup"
			></new-orders-table>
			<preload v-else></preload>
		</div>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NewOrdersTable from "@/components/Fleet/WorkOrdersStatistics/Planer/NewOrders/NewOrdersTable/NewOrdersTable";
import Preload from "@/shared/Preload/Preload";

export default {
	name: "NewOrders",
	components: {
		NewOrdersTable,
		Preload
	},
	props: {
		permissions: Object,
		workOrderId: Number
	},
	computed: mapGetters([ 'newWorkOrderFilter', 'newWorkOrderList' ]),
	data: () => ({
		isNewOrders: true,
		status_id: null,
		client: null,
		unit: null,
		unit_type: null
	}),
	methods: {
		...mapActions([ 'onNewWorkOrder' ]),
		onClose() {
			this.$emit('updateNewOrdersClose');
		},
		onDelete() {
			this.$emit('updateDelete');
		},
		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? null;
		},
		onNewOrder(id) {
			this.$emit('updateNewOrder', id);
		},
		onCommentsPopup(values) {
			this.$emit('updateCommentsPopup', values);
		},
	},
	mounted() {
		this.onNewWorkOrder();
	}
};
</script>

<style scoped lang="scss">
@import "NewOrders";
</style>
